import React from 'react';
import styled from 'styled-components';
import { Select, Space } from 'antd';
import type { CustomSelectMultipleProps, CustomSelectProps } from './types';

export const SelectWrapper = styled((props: CustomSelectProps) => <Select {...props} />)`
	.ant-select-selector {
		height: 40px !important;
		font-size: 16px !important;
		padding-top: 5px !important;
		font-weight: 400 !important;
		border-radius: 4px !important;
		padding-bottom: 5px !important;
		border: 1px solid ${({ theme }) => theme.palette.secondary['150']} !important;

		@media (max-width: 1389px) {
			font-size: 12px !important;
		}
	}

	.ant-select-arrow {
		color: ${({ disabled, theme }) => (disabled ? theme.palette.secondary['250'] : theme.colors.text)};
		width: 16px;
		font-weight: 600 !important;
	}
`;

export const SelectMultipleWrapper = styled((props: CustomSelectMultipleProps) => <SelectWrapper {...props} />)`
	.ant-select-selector {
		min-height: 40px !important;
		max-height: 80px !important;
		height: auto !important;
		overflow-y: auto !important;
		padding: 2px 8px !important;
	}

	.ant-select-selection-overflow {
		max-height: 72px !important;
		overflow-y: auto !important;
		flex-wrap: wrap !important;
	}

	.ant-select-selection-item {
		margin-top: 2px !important;
		margin-bottom: 2px !important;
		height: 30px !important;
		line-height: 30px !important;
	}

	.ant-select-selection-item-content {
		order: 2 !important;
	}

	.ant-select-selection-item-remove {
		order: 1 !important;
		font-size: 14px !important;
		margin-right: 3px !important;
	}

	.ant-select-selection-search {
		margin-top: 2px !important;
		margin-bottom: 2px !important;
	}
`;

export const SpaceWrapper = styled(Space)`
	padding: 0 8px 4px !important;
	width: 100% !important;

	.ant-space-item:first-child {
		width: 70% !important;
	}

	.ant-space-item:last-child {
		width: 30% !important;
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
	}

	.ant-space-item {
		.ant-input {
			height: 40px !important;
			border-radius: 4px !important;
			border: 1px solid ${({ theme }) => theme.palette.secondary['150']} !important;
			font-size: 16px !important;
			line-height: 40px !important;
		}
		.ant-btn {
			color: ${({ theme }) => theme.colors.primary} !important;
			font-size: 14px !important;
		}
	}

	/* Responsive adjustments for smaller screens */
	@media (max-width: 1389px) {
		.ant-space-item:first-child {
			width: 60% !important;
		}

		.ant-space-item:last-child {
			width: 40% !important;
		}

		.ant-space-item {
			.ant-input {
				font-size: 12px !important;
			}
			.ant-btn {
				font-size: 11px !important;
			}
		}
	}
`;
